import moment from 'moment';

const handleDate = (date) => {
  const formattedDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
  return formattedDate === 'Invalid Date' ? '-' : formattedDate;
};

export const PAID_AMOUNT_COLUMNS = [
  {
    key: 'prepaymentInvoiceNumber',
    label: 'createInvoice.prepayment_invoice_number',
    body: (rowItem) => `${rowItem.prepaymentInvoiceNumber}`,
    _props: { scope: 'col' },
  },
  {
    key: 'prepaymentInvoiceIssueDate',
    label: 'createInvoice.prepayment_invoice_issue_date',
    body: (rowItem) => handleDate(rowItem.prepaymentInvoiceIssueDate),
    _props: { scope: 'col' },
  },
  {
    key: 'prepaymentTaxableAmount',
    label: 'createInvoice.prepayment_taxable_amount',
    body: (rowItem) =>
      rowItem.prepaymentTaxableAmount
        ? `${Number(rowItem.prepaymentTaxableAmount).toFixed(3)} BHD`
        : '-',
    _props: { scope: 'col' },
  },
  {
    key: 'prepaymentVatRate',
    label: 'createInvoice.prepayment_VAT_rate',
    body: (rowItem) =>
      rowItem.prepaymentVatRate ? `${rowItem.prepaymentVatRate}%` : '-',
    _props: { scope: 'col' },
  },
  {
    key: 'prepaidVatAmount',
    label: 'createInvoice.prepayment_VAT_amount',
    body: (rowItem) =>
      rowItem.prepaidVatAmount
        ? `${Number(rowItem.prepaidVatAmount).toFixed(3)} BHD`
        : '-',
    _props: { scope: 'col' },
  },
];
